
import { defineComponent, PropType } from "vue";

type FieldConfig = {
  label: string;
  key: string;
  format?: (data: any) => string;
};

export default defineComponent({
  name: "RowDetailsModal",
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
    fields: { type: Array as PropType<FieldConfig[]>, required: true },
    data: { type: Object as PropType<any>, required: false },
    loading: { type: Boolean, default: false },
  },
  setup(props) {
    const resolvePath = (obj: any, path: string) => {
      if (!obj || !path) return undefined;
      return path.split(".").reduce((acc, key) => acc?.[key], obj);
    };

    const resolveValue = (field: FieldConfig) => {
      if (field.format) {
        return field.format(props.data);
      }
      const value = resolvePath(props.data, field.key);
      if (value === null || value === undefined || value === "") return "-";
      return String(value);
    };

    return { resolveValue };
  },
});
